import { atom } from "../../../app-jotai";

/**
 * Editor panel state. `open` is the only thing callers set from outside;
 * `initialText` seeds a hand-off from the Import or AI dialog.
 */
export const kmdEditorAtom = atom<{ open: boolean; initialText?: string }>({
  open: false,
});

/** persisted panel width in px (Q1: the panel remembers how wide you made it) */
export const KMD_EDITOR_WIDTH_KEY = "khiyarsa:kmd-editor-width";

export const MIN_PANEL_WIDTH = 320;
export const MAX_PANEL_WIDTH = 900;
export const DEFAULT_PANEL_WIDTH = 440;

export const readStoredWidth = (): number => {
  try {
    const raw = window.localStorage.getItem(KMD_EDITOR_WIDTH_KEY);
    const value = raw ? Number(raw) : NaN;
    return Number.isFinite(value)
      ? Math.min(MAX_PANEL_WIDTH, Math.max(MIN_PANEL_WIDTH, value))
      : DEFAULT_PANEL_WIDTH;
  } catch {
    return DEFAULT_PANEL_WIDTH;
  }
};

export const storeWidth = (width: number): void => {
  try {
    window.localStorage.setItem(
      KMD_EDITOR_WIDTH_KEY,
      String(Math.round(width)),
    );
  } catch {
    /* ignore */
  }
};
